export enum DCTTransactionEligibility {
  PUSH_ONLY,
  PULL_ONLY,
  PUSH_AND_PULL
}
